import { Locale, localeNameConfig } from '@ps-smart-cp/ppfw-client';
import { enumToName } from '../utils';

function toDisplay(rawValue: string, locale: Locale) {
  return enumToName(Locale, localeNameConfig)(rawValue, locale).split(' ')[1];
}

export const locale = {
  toDisplay,
};
